// Shared news article card + category image helper.
import { Link } from "react-router-dom";
import { Clock, Eye } from "lucide-react";
import { API } from "../../utils/apiUrl";

export const categoryImage = (category) => {
  const c = (category || "").toLowerCase();
  if (c.includes("cricket")) return "/images/news/news_cricket.jpg";
  if (c.includes("tennis")) return "/images/news/news_tennis.jpg";
  if (c.includes("formula")) return "/images/news/news_f1.jpg";
  if (c.includes("nba")) return "/images/news/news_nba.jpg";
  if (c.includes("other")) return "/images/news/news_general.jpg";
  return "/images/news/news_football.jpg";
};

export const articleImage = (a) =>
  a?.image_type === "ai" ? `${API}/news/image/${a.slug}` : categoryImage(a?.category);

export const timeAgo = (iso) => {
  if (!iso) return "";
  const mins = Math.max(1, Math.floor((Date.now() - new Date(iso).getTime()) / 60000));
  if (mins < 60) return `${mins}m ago`;
  const h = Math.floor(mins / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
};

export const NewsCard = ({ a, big = false }) => (
  <Link
    to={`/news/${a.slug}`}
    className="group block rounded-2xl overflow-hidden bg-slate-900/70 border border-slate-800 hover:border-emerald-500/40 transition-colors"
    data-testid={`news-card-${a.slug}`}
  >
    <div className={`relative overflow-hidden ${big ? "h-56 sm:h-72" : "h-40"}`}>
      <img
        src={articleImage(a)}
        alt={a.h1 || a.seo_title}
        loading="lazy"
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
      />
      <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-slate-950/80 backdrop-blur text-emerald-300 text-[10px] font-extrabold uppercase tracking-widest">
        {a.category}
      </span>
    </div>
    <div className="p-4">
      <h3 className={`font-extrabold text-white leading-snug mb-2 group-hover:text-emerald-300 transition-colors ${big ? "text-xl sm:text-2xl" : "text-sm sm:text-base"}`}>
        {a.h1 || a.seo_title}
      </h3>
      {big && a.excerpt && <p className="text-sm text-slate-400 mb-3 line-clamp-2">{a.excerpt}</p>}
      <div className="flex items-center gap-3 text-[11px] text-slate-500">
        <span className="inline-flex items-center gap-1"><Clock className="w-3 h-3" /> {timeAgo(a.published_at)}</span>
        <span>{a.reading_minutes || 3} min read</span>
        {a.views > 0 && <span className="inline-flex items-center gap-1"><Eye className="w-3 h-3" /> {a.views}</span>}
      </div>
    </div>
  </Link>
);
